// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3BaCg","inner":"Form_inner__1laJW","range":"Form_range__QEMTt","name":"Form_name__HaIZf","actions":"Form_actions__2K3Dj"};